import { render, staticRenderFns } from "./Revaluation.vue?vue&type=template&id=fa622358&scoped=true"
import script from "./Revaluation.vue?vue&type=script&lang=js"
export * from "./Revaluation.vue?vue&type=script&lang=js"
import style0 from "./Revaluation.vue?vue&type=style&index=0&id=fa622358&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa622358",
  null
  
)

export default component.exports